// extracted by mini-css-extract-plugin
export default {"container":"index_container__Tg7rs","head":"index_head__q6C7v","avatar":"index_avatar__kVr-A","title":"index_title__dBDDy","type":"index_type__1hnNQ","foot":"index_foot__AV3SE"};